import type { DirectiveDescriptor } from '@mdxeditor/editor';

import { POLL_MDX_DIRECTIVE_NAME } from './pollMdxDirectiveConstants';
import { PollMdxDirectiveEditor } from './PollMdxDirectiveEditor';

export const PollMdxDirectiveDescriptor: DirectiveDescriptor = {
  name: POLL_MDX_DIRECTIVE_NAME,
  testNode(node) {
    return node.name === POLL_MDX_DIRECTIVE_NAME;
  },
  Editor: PollMdxDirectiveEditor,
  hasChildren: false,
  attributes: [],
};
